module.exports = __webpack_public_path__ + "img/sousuo.184f0f6d.png";